module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Book.bc736ff5.eot";